<p-toast></p-toast>

<div class="p-grid">
  <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-2 p-px-sm-2 p-px-md-2 p-px-lg-2 p-px-xl-2">
    <p-panel [collapsed]="true" [toggleable]="true">
      <ng-template pTemplate="header">
        <p class="p-m-0" style="color: #232c70">
          <b>Filtrar certificados</b> <small class="p-ml-2 p-text-light">Presiona en el ícono para mostrar más opciones</small>
        </p>
    </ng-template>
      <div class="p-grid p-jc-between">
        <div class="p-d-flex p-flex-column p-flex-md-row">
          <div class="p-d-flex p-flex-column p-mr-3 p-mb-2">
            <small class="p-pl-2">Estado</small>
            <p-dropdown [options]="estados" (onChange)="filtrarCertificados()" [(ngModel)]="filter.estado" placeholder="Mostrar todo"></p-dropdown>
          </div>
        </div>
  
          <div class="p-d-flex p-flex-column p-mr-3 p-mb-2">
            <small class="p-pl-2">Ordenar por</small>
            <p-dropdown [options]="ordenar" name="ordenar" (onChange)="ordenarCertificados($event.value)" label="label" value="value" placeholder="Últimos certificados"></p-dropdown>
          </div>
      </div>
  </p-panel>
  </div>


  <div *ngIf="!loading" class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-3 p-px-sm-3 p-px-md-3 p-px-lg-3 p-px-xl-3">
    
    <div *ngIf="!certificadosFiltrados.length" class="p-grid certificado-card">
      <div class="p-col-12 p-text-center">
        <h3>No hay certificados que mostrar.</h3>
      </div>
      
    </div>

      <!-- tarjeta certificado -->
        <div class="p-grid certificado-card" *ngFor="let certificado of certificadosFiltrados; let i = index">
          <div class="p-col-12 p-lg-4">
            <div class="p-d-flex p-flex-column">
              <h3 class="p-m-0">{{certificado.curso}}</h3>
              <p class="p-m-0" *ngIf="certificado.certificateNo"><small>ID° Certificado:<br>#{{certificado.certificateNo}}</small></p>
            </div>
          </div>
          <div class="p-col-12 p-lg-4">
            <p class="p-m-0"> 
              <b>Fecha emisión:</b><br>
              <span style="font-size: 0.9rem">{{certificado.fecha_emision | date: "d 'de' MMMM 'de' y 'a las' H:mm 'hrs.'" : 'UTC +0': 'es' }}</span><br>
              <span *ngIf="certificado.estado == 'NO GENERADO'" class="text-muted font-light"><small>Para visualizar y descargar su certificado debe generarlo presionando el botón. Se enviará una copia a su correo con el certificado.</small></span>
              <span *ngIf="certificado.estado == 'ACTIVO' 
                || certificado.estado == 'GENERANDO' 
                || certificado.estado == 'GENERADO'" 
              class="text-muted font-light"><small>La fecha de emisión corresponde al momento en que el alumno aprueba el curso.</small></span>
              <span *ngIf="certificado.estado == 'POR PAGAR'" class="text-muted font-light"><small>Para generar y obtener su certificado debe realizar el pago y enviar el comprobante.</small></span>
            </p>
          </div> 
          <div class="p-col-12 p-lg-4" style="border-left: 1px solid #ddd;">
            <div class="p-d-flex p-jc-center">
            <button
              *ngIf="certificado.estado == 'ACTIVO' 
              || certificado.estado == 'GENERANDO' 
              || certificado.estado == 'GENERADO'"
              pButton
              icon="pi pi-external-link"
              [label]="certificado.loading ? 'Comprobando...' : 'Ver certificado'"
              class="p-pt-2 p-pb-2 p-pl-4 p-pr-4 p-button-rounded btn-ver-certificado"
              (click)="verCertificado(certificado.id_certificado, i)"
              [loading]="certificado.loading ? certificado.loading : false"
              [disabled]="certificado.loading ? certificado.loading : false"
              >
            </button>
            <button
              *ngIf="certificado.estado == 'NO GENERADO'"
              pButton
              icon="pi pi-replay"
              [label]="certificado.loading ? 'Generando...':'Generar certificado'"
              class="p-pt-2 p-pb-2 p-pl-4 p-pr-4 p-button-rounded btn-generar-certificado"
              (click)="generarCertificado(certificado, i)"
              [loading]="certificado.loading ? certificado.loading : false"
              [disabled]="certificado.loading ? certificado.loading : false"
              >
            </button>
            </div>
          </div>
        </div>
    
  </div>

  <div *ngIf="loading"  class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12 p-px-3 p-px-sm-3 p-px-md-3 p-px-lg-3 p-px-xl-3">
    <div class="p-grid certificado-card datagrid__row" *ngFor="let certificado of [1,2,3]">
      <div class="p-col-12 p-lg-4">
        <div class="p-d-flex p-flex-column">
          <div class="p-mb-1"><p-skeleton width="100%" height="1.8rem"></p-skeleton></div>
          <div class="p-mb-4"><p-skeleton width="50%" height="1.4rem"></p-skeleton></div>
          <div><p-skeleton width="70%" height="1.2rem"></p-skeleton></div>
        </div>
      </div>
      <div class="p-col-12 p-lg-5">
        <div><p-skeleton width="100%" height="1.8rem"></p-skeleton></div>
      </div>
      <div class="p-col-12 p-lg-3" style="border-left: 1px solid #ddd;">
        <div class="p-d-flex p-flex-column">
          <div class="p-mb-1"><p-skeleton width="40%" height="1.5rem"></p-skeleton></div>
          <div class="p-mb-1"><p-skeleton width="100%" height="1.8rem"></p-skeleton></div>
          <div><small><p-skeleton width="80%" height="1.3rem"></p-skeleton></small></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--MODAL INFO GENERACION CERTIFICADO-->
<p-dialog 
  header="Su certificado se está generando" 
  [(visible)]="displayModal" 
  [style]="{width: '30vw'}" 
  [breakpoints]="{'1600px':'50vw' , '960px': '75vw', '640px': '95vw'}" 
  [modal]="true"  
>
  La generación del certificado puede tardar varios minutos. Por favor vuelva en un momento a ver su 
  certificado. Cuando se encuentre listo será enviado a su correo electrónico.
  <p-footer>
    <button pButton type="button" icon="pi pi-check" label="Entendido" (click)="displayModal = false" class="btn-primary-outline"></button>
  </p-footer>
</p-dialog>